import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthGuardService } from './services/auth-guard.service';
import { OverviewComponent } from '../overview/overview.component';
import { redirectToCeComponent } from './redirecting-to-netcore-ce/redirect-to-ce.component';
import { CustomerExperienceRequestAccessComponent } from './customer-experience-request-access/customer-experience-request-access.component';
import { OnsiteJourneyComponent } from './onsite-journey/onsite-journey.component';

const routes: Routes = [
  {
    path: 'testgroup-pair',
    canActivate: [AuthGuardService],
    loadChildren: '../pairing-confirmation-webpage/pairing-confirmation-webpage.module#PairingConfirmationWebpageModule'
  },
  {
    path: 'auth',
    canActivate: [AuthGuardService],
    loadChildren: '../loginApp/login-app.module#LoginAppModule'
  },
  {
    path: 'design-components',
    canActivate: [AuthGuardService],
    loadChildren: '../design-components/design-components.module#DesignComponentsModule'
  },
  {
    path: 'overview',
    canActivate: [AuthGuardService],
    component: OverviewComponent
  },
  {
    path: 'actions',
    canActivate: [AuthGuardService],
    loadChildren: '../datasource/datasource.module#DatasourceModule'
  },
  {
    path: 'segments',
    canActivate: [AuthGuardService],
    loadChildren: '../segments/segments.module#SegmentsModule'
  },
  {
    path: 'test-groups',
    canActivate: [AuthGuardService],
    loadChildren: '../test-groups/test-groups.module#TestGroupsModule'
  },
  {
    path: 'settings',
    canActivate: [AuthGuardService],
    loadChildren: '../settings/settings.module#SettingsModule'
  },
  {
    path: 'user-settings',
    canActivate: [AuthGuardService],
    loadChildren: '../settings/user-settings/user-settings.module#UserSettingsModule'
  },
  {
    path: 'app-settings',
    canActivate: [AuthGuardService],
    loadChildren: '../settings/app-settings/app-settings.module#AppSettingsModule'
  },
  /*   {
      path: 'company-settings',
      canActivate: [AuthGuardService],
      loadChildren: '../settings/company-settings/company-settings.module#CompanySettingsModule'
    }, */
  {
    path: 'context-builder/:supportedNudgeType',
    canActivate: [AuthGuardService],
    loadChildren: '../product-journey-manager/product-journey-manager.module#ProductJourneyManagerModule'
  },
  {
    path: 'redirecting-to-netcore-ce',
    canActivate: [AuthGuardService],
    component: redirectToCeComponent
  },
  {
    path: 'ce-request-access',
    canActivate: [AuthGuardService],
    component: CustomerExperienceRequestAccessComponent
  },
  {
    path: 'onsite-journey',
    canActivate: [AuthGuardService],
    component: OnsiteJourneyComponent
  },
  /*  {
     path: 'user-management',
     canActivate: [AuthGuardService],
     loadChildren: '../user-management/user-management.module#UserManagementModule'
   }, */
  {
    path: '**',
    redirectTo: 'overview'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
